module.exports = __webpack_public_path__ + "assets/img/third_bg.a9344e9d.png";